const IMG = {
  gate: "https://images.unsplash.com/photo-1608126842524-7e10c3b18453?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxtZXRhbCUyMGZlbmNlJTIwcmVwYWlyJTIwdHJhaWxlciUyMHdlbGRpbmd8ZW58MHx8fHwxNzg4NDY5NDcxfDA&ixlib=rb-4.1.0&q=85",
  trailer: "https://images.unsplash.com/photo-1572879012509-30625eeffa78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxtZXRhbCUyMGZlbmNlJTIwcmVwYWlyJTIwdHJhaWxlciUyMHdlbGRpbmd8ZW58MHx8fHwxNzg4NDY5NDcxfDA&ixlib=rb-4.1.0&q=85",
  heavy: "https://images.unsplash.com/photo-1649034872337-feaa751786ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxoZWF2eSUyMG1hY2hpbmVyeSUyMGV4Y2F2YXRvciUyMG1ldGFsfGVufDB8fHx8MTc4ODQ2OTQ3NXww&ixlib=rb-4.1.0&q=85",
  emergency: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx3ZWxkZXIlMjBzcGFya3MlMjBtZXRhbCUyMHJlcGFpcnxlbnwwfHx8fDE3ODg0Njk0NzF8MA&ixlib=rb-4.1.0&q=85",
  structural: "https://images.unsplash.com/photo-1698664683348-f9f35b809821?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHx3ZWxkZXIlMjBzcGFya3MlMjBtZXRhbCUyMHJlcGFpcnxlbnwwfHx8fDE3ODg0Njk0NzF8MA&ixlib=rb-4.1.0&q=85",
  sparks: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHx3ZWxkZXIlMjBzcGFya3MlMjBtZXRhbCUyMHJlcGFpcnxlbnwwfHx8fDE3ODg0Njk0NzF8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "gate-fence-repair",
    name: "Gate & Fence Repair",
    blurb: "Sagging driveway gates, broken hinges, rusted posts, storm-damaged fence panels — fixed where they stand.",
    image: IMG.gate,
    audience: "Residential & Commercial",
    plain: "If your gate drags, won't latch, or the hinge has torn clean off the post, you don't need a new gate — you need a welder who comes to you. We rehang sagging gates, rebuild broken hinges, weld cracked wrought iron, reset rusted posts, and reinforce latches so the fix lasts. Most gate repairs are finished in a single visit, and you get the price before we strike an arc.",
    whoNeeds: [
      "Homeowners with a driveway gate that sags, drags, or won't close",
      "Anyone whose wrought iron fence was hit by a car or storm",
      "Ranch and acreage owners with cattle gates and pipe fencing down",
      "Property managers responsible for community entry gates",
      "Businesses with security gates or rolling fence sections stuck open",
    ],
    materials: ["Steel tube and pipe gates", "Wrought iron and ornamental steel", "Aluminum gates and fencing", "Stainless hardware and hinges"],
    expect: [
      "Text us a photo of the gate and the damage — we reply with a straight price, usually within the hour.",
      "We schedule a window that works for you, often same-day or next-day.",
      "Our rig parks at your gate. No need to remove it or haul it anywhere.",
      "You approve the finished repair before we pack up, and it's covered by our workmanship warranty.",
    ],
    meta: { title: "Gate & Fence Repair in Fort Worth, TX | Mobile Welder Comes to You", description: "Sagging gate, broken hinge, or rusted fence post? Our mobile welders repair gates and fences on-site across Fort Worth & Tarrant County. Text a photo for a fast quote." },
  },
  {
    slug: "trailer-hitch-repair",
    name: "Trailer & Hitch Repair",
    blurb: "Cracked tongues, broken couplers, bent ramps, and gooseneck repairs that get you back on the road safely.",
    image: IMG.trailer,
    audience: "Haulers, Ranchers & Contractors",
    plain: "A cracked trailer frame or a failing hitch isn't just an inconvenience — it's a road hazard. We weld trailer tongues, replace couplers, rebuild ramp hinges, reinforce goosenecks, and patch rusted decks right where the trailer sits. Bring it to us or we'll come to your yard, barn, or job site.",
    whoNeeds: [
      "Contractors with a utility or equipment trailer down mid-job",
      "Horse and livestock owners with trailer frame or ramp damage",
      "Hotshot and haul drivers with cracked gooseneck or bumper-pull hitches",
      "Landscapers whose trailer gates and ramps have torn loose",
    ],
    materials: ["Structural steel channel and angle", "Diamond plate decking", "Aluminum trailer frames", "Hitch and coupler assemblies"],
    expect: [
      "Send a photo of the crack or break plus the trailer's VIN plate if handy — it helps us spec the right material.",
      "We quote a flat price before any work starts.",
      "Repairs happen at your location or ours — whichever is safer for the load.",
      "We load-test the repair and walk you through it before we leave.",
    ],
    meta: { title: "Trailer & Hitch Repair in Fort Worth, TX | On-Site Mobile Welding", description: "Cracked trailer tongue, broken coupler, or bent ramp? Mobile trailer welding repair across Fort Worth, Weatherford & Tarrant/Parker counties. Text a photo for a quote." },
  },
  {
    slug: "heavy-equipment-repair",
    name: "Heavy Equipment Repair",
    blurb: "Excavator buckets, loader arms, dozer blades — welded and hardfaced on your job site, not hauled to a shop.",
    image: IMG.heavy,
    audience: "Construction & Earthmoving",
    plain: "Every hour a machine sits broken, your crew stands still. We bring the welding rig to your job site and repair cracked booms, rebuild bucket edges, replace teeth and wear plates, and hardface high-wear surfaces on the spot. No lowboy, no shop queue, no week of downtime.",
    whoNeeds: [
      "Excavation and site-work contractors with down machines",
      "Demolition crews needing bucket and thumb repairs",
      "Aggregate, quarry, and landscape supply operations",
      "Ranches and farms with tractor implements and ag equipment",
    ],
    materials: ["AR400/AR500 abrasion-resistant plate", "High-carbon bucket edges and teeth", "Structural steel booms and frames", "Hardfacing wire and build-up alloys"],
    expect: [
      "Call or text photos of the damage and the machine model — we confirm the repair plan and price.",
      "We dispatch with the right rods, wire, and plate for your steel grade.",
      "Cracks are gouged out properly before welding — no cosmetic cover-ups.",
      "The machine goes back to work the same visit in most cases.",
    ],
    meta: { title: "Heavy Equipment Welding Repair in Fort Worth, TX | On-Site Field Welding", description: "Excavator buckets, loader arms, dozer blades repaired on your job site. Mobile heavy equipment welding across Fort Worth & Parker County. Call for dispatch." },
  },
  {
    slug: "emergency-welding-repair",
    name: "Emergency / 24-7 Repair",
    blurb: "Structural breaks, stuck-open security gates, and down equipment — answered around the clock.",
    image: IMG.emergency,
    audience: "Rapid Dispatch",
    plain: "Some breaks can't wait until morning: a security gate stuck open at your business, a trailer down on the shoulder, a handrail torn loose where people walk. Our emergency line is answered 24/7, and a welder rolls with a fully stocked rig — nights, weekends, and holidays included.",
    whoNeeds: [
      "Businesses with a security gate or fence breach that can't stay open overnight",
      "Drivers stranded with a broken trailer or hitch",
      "Facilities with a failed handrail, dock plate, or structural member",
      "Contractors facing a deadline with broken iron on site",
    ],
    materials: ["All structural steels", "Aluminum and stainless", "On-truck plate, angle, and tube stock", "Emergency fasteners and bracing"],
    expect: [
      "Call the emergency line and describe the break — we tell you immediately if it's safe to wait or needs us now.",
      "You get a price range on the phone, confirmed in writing on arrival.",
      "We secure the area first, then repair.",
      "If a permanent fix needs a follow-up visit, we make it safe that night and schedule the finish.",
    ],
    meta: { title: "24/7 Emergency Welding Repair in Fort Worth, TX | Mobile Welder On Call", description: "Welding emergency in Fort Worth? Broken gates, structural breaks, and down equipment repaired around the clock. Call now for 24/7 mobile dispatch." },
  },
  {
    slug: "structural-repair-reinforcement",
    name: "Structural Repair & Reinforcement",
    blurb: "Beams, columns, mezzanines, bollards, and canopies — field-welded to engineer specifications.",
    image: IMG.structural,
    audience: "Contractors & Facilities",
    plain: "We perform field structural steel repair and reinforcement per engineer-of-record details: column stiffeners, beam splice repairs, mezzanine modifications, canopy reinforcement, bollard and guard installation, and post-damage remediation. Our welders work to AWS D1.1 structural welding code, and we coordinate with your engineer or GC on documentation.",
    whoNeeds: [
      "General contractors needing field welders for steel remediation",
      "Facilities and warehouse managers with damaged columns or racks",
      "Property owners directed by an engineer to reinforce framing",
      "Insurers and adjusters needing documented structural repairs",
    ],
    materials: ["Wide-flange beams and columns (A36/A992)", "HSS tube and structural angle", "Connection plate and stiffener stock", "Stainless and aluminum structural sections"],
    expect: [
      "Send the engineer's detail or photos of the damage — we scope and price against the spec.",
      "Weld procedures and welder qualifications available on request.",
      "Work is executed to AWS D1.1 with clean, inspectable welds.",
      "Documentation package provided for your engineer or building official.",
    ],
    meta: { title: "Structural Steel Repair & Reinforcement in Fort Worth, TX | AWS D1.1 Field Welding", description: "Field structural welding for beams, columns, mezzanines & canopies in Fort Worth. AWS D1.1 welders, engineer-spec repairs, full documentation. Request a quote." },
  },
  {
    slug: "pipe-repair-patching",
    name: "Pipe Repair & Patching",
    blurb: "Non-pressurized pipe, handrails, and safety railing — repaired, re-anchored, and code-conscious.",
    image: IMG.sparks,
    audience: "Facilities & Compliance",
    plain: "From a rusted-out pipe rack leg to a wobbly ADA handrail, pipe failures are usually small jobs with big liability. We repair and patch non-pressurized pipe, rebuild commercial handrails and stair stringers, re-anchor guard rails, and bring railing back to a safe, solid state — often same-day.",
    whoNeeds: [
      "Property managers with loose or failed handrails and guardrails",
      "Facilities teams with damaged pipe bollards or rack protectors",
      "Businesses cited for railing or safety issues",
      "Homeowners with iron porch rails pulling away from concrete",
    ],
    materials: ["Schedule 40/80 steel pipe (non-pressurized)", "Stainless handrail tube", "Aluminum railing systems", "Pipe bollards and safety rail"],
    expect: [
      "Text a photo of the rail or pipe and its surroundings — we quote from photos in most cases.",
      "We match existing material and finish where possible.",
      "Anchors are reset into sound substrate, not just re-welded at the surface.",
      "You get a solid, shake-tested rail before we leave.",
    ],
    meta: { title: "Pipe & Handrail Welding Repair in Fort Worth, TX | Mobile On-Site Service", description: "Loose handrails, damaged bollards, rusted pipe racks repaired on-site in Fort Worth. Mobile pipe welding for facilities & homeowners. Text a photo for a quote." },
  },
  {
    slug: "preventative-maintenance-programs",
    name: "Preventative Maintenance Programs",
    blurb: "Scheduled weld inspections and reinforcement for fleets, facilities, and equipment — before things break.",
    image: IMG.heavy,
    audience: "Commercial Accounts",
    plain: "Emergency repairs cost triple what planned maintenance does. Our maintenance programs put your trailers, gates, railings, and equipment on a scheduled inspection cycle: we find stress cracks early, gouge and repair them properly, add gussets where fatigue is starting, and replace wear parts on your calendar — not after a failure.",
    whoNeeds: [
      "Fleet operators with multiple trailers or trucks",
      "Property managers with gates, rails, and bollards across sites",
      "Contractors running high-hours equipment",
      "Facilities wanting documented inspection and repair records",
    ],
    materials: ["All program work matched to your existing steel, aluminum, and stainless", "Wear plate and gusset stock", "OEM-equivalent hardware", "Coatings and touch-up finishes"],
    expect: [
      "We walk your fleet or facility and build a prioritized repair list — free for program accounts.",
      "You approve a fixed per-visit or per-unit price schedule.",
      "Visits are scheduled around your operations, including off-hours.",
      "Every visit ends with a written condition report for your records.",
    ],
    meta: { title: "Welding Preventative Maintenance Programs in Fort Worth, TX | Fleet & Facility Plans", description: "Scheduled welding inspection and repair for fleets, gates, and facilities across Fort Worth. Fixed pricing, written reports, priority dispatch. Request a program quote." },
  },
  {
    slug: "fabrication-custom-builds",
    name: "New Fabrication & Custom Builds",
    blurb: "When repair genuinely isn't the right call — replacement brackets, baseplates, and custom pieces built on-site.",
    image: IMG.structural,
    audience: "When Repair Isn't the Right Fit",
    plain: "We're a repair-first shop, and we'll tell you honestly when something isn't worth fixing. When replacement is the right call, we fabricate what you need on-site: custom brackets and baseplates, replacement gate sections, steel stiffeners, retrofit mounts, and one-off pieces that would take a fab shop weeks to schedule.",
    whoNeeds: [
      "Customers whose equipment is too far gone to safely repair",
      "Contractors needing a one-off bracket or plate without shop lead times",
      "Property owners replacing beyond-repair gate sections",
      "Anyone told 'we can build it in 4–6 weeks' who needs it this week",
    ],
    materials: ["Steel plate, tube, and angle", "Aluminum sheet and extrusion", "Stainless for food-adjacent and outdoor exposure", "Hardware, hinges, and mounting systems"],
    expect: [
      "We assess whether repair or replacement is the better value — and tell you straight.",
      "You get a fixed quote with material and finish specified.",
      "Most single-piece fabrications are built and installed in one visit.",
      "The piece is fit-checked and load-verified before we call it done.",
    ],
    meta: { title: "On-Site Custom Metal Fabrication in Fort Worth, TX | When Repair Isn't Enough", description: "Custom brackets, baseplates, and replacement sections fabricated on-site in Fort Worth. Honest repair-vs-replace advice. Text photos for a fast quote." },
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
export const TOP_SERVICES = SERVICES.slice(0, 4);
export const IMAGES = IMG;
